<div class="flex items-center gap-3">
  @if (loadingVisible()) {
    @if (pillLoaderVisible()) {
      <ngx-skeleton-loader class="h-6" [theme]="{ 'border-radius': '100vw', height: '24px', width: '52px' }" />
    } @else {
      <ngx-skeleton-loader class="h-4" [theme]="{ 'border-radius': '100vw', height: '16px', width: '16px' }" />
    }
  } @else {
    @if (
      (currentRatio() === null || currentRatio() === undefined) &&
      (currentCount() === null || currentCount() === undefined)
    ) {
      <ng-container *ngTemplateOutlet="statusBadge" />
    } @else {
      <div
        class="flex items-center justify-center gap-1 rounded-full px-2 py-1"
        [style.background-color]="pillBackgroundColor()"
      >
        <ng-container *ngTemplateOutlet="statusBadge" />
        <div class="flex items-center justify-center text-[10px] font-bold leading-4" [style.color]="statusColor()">
          @if (currentRatio() !== null && currentRatio() !== undefined) {
            {{ currentRatio() | percent: '1.1-1' }}
          } @else {
            {{ currentCount() ?? 0 }}/1
          }
        </div>
      </div>
    }
  }

  @if (jumpActionLoaderVisible()) {
    <ngx-skeleton-loader class="h-6" [theme]="{ 'border-radius': '100vw', height: '24px', width: '24px' }" />
  } @else {
    @if (jumpActionVisible()) {
      <button
        mat-icon-button
        type="button"
        class="mat-secondary-gray-border-button-color"
        [disabled]="jumpActionDisabledVisible()"
        (click)="onJumpActionClick($event)"
      >
        <app-icon src="/icons/arrow-right.svg" [size]="12" />
      </button>
    }
  }
</div>

<ng-template #statusBadge>
  @if (!hideStatusBadge()) {
    <app-icon
      [src]="statusIcon()"
      [size]="16"
      [color]="statusColor()"
      [backgroundColor]="statusBackgroundColor()"
      [matTooltip]="'shared.analyticsStatus.' + (status() | lowercase) | translate"
      [matTooltipDisabled]="executionStatus() !== EMatchingType.planned"
    />
  }
</ng-template>
